module.exports = __webpack_public_path__ + "static/img/民信服务号.557985a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/民信服务号.png
// module id = IGV0
// module chunks = 58